import controleSaldos from '@/core/store/relatorios/controle-saldos'
import controleAdesoes from '@/core/store/relatorios/controle-adesoes'

export default {
	modules: {
		controleSaldos,
		controleAdesoes,
	},
}
